import { useState } from 'react';
import './document-center.css';
import { getCardRate, setCardRate, useDcVersion } from './store';
import { SectionHeader } from '../settings-d/primitives';

/**
 * Settings › Virtual cards (V1, D200). Mounted as a slot in the settings-d
 * shell, so it uses that shell's `setd-card` chrome. In V1 staff charge cards in
 * their own card machine: no processor connection, no "ELVA charges cards" switch.
 */
export function VirtualCardsSettings() {
  useDcVersion();
  const [rate, setRate] = useState(getCardRate().toFixed(1));
  const [saved, setSaved] = useState(false);

  const parsed = Number(rate.trim());
  const valid = rate.trim() !== '' && Number.isFinite(parsed) && parsed >= 0 && parsed <= 10;

  return (
    <>
      <section className="setd-card">
        <SectionHeader n="" title="Your card processor’s rate" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14, paddingTop: 14 }}>
          <label className="dc-flabel">
            <span id="dc-rate-help" className="dc-meta" style={{ fontWeight: 400 }}>Used only to show what card payments cost you. It isn&rsquo;t a score.</span>
            <span style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
              <input
                className="dc-field num"
                style={{ width: 110 }}
                aria-label="Your card processor’s rate, in percent"
                aria-describedby="dc-rate-help"
                aria-invalid={!valid}
                inputMode="decimal"
                value={rate}
                onChange={(e) => { setRate(e.target.value); setSaved(false); }}
              />
              <span aria-hidden="true">%</span>
              <button
                type="button"
                className="dc-btn dc-btn-primary"
                disabled={!valid}
                onClick={() => { setCardRate(parsed); setRate(parsed.toFixed(1)); setSaved(true); }}
              >
                Save
              </button>
              {saved ? <span className="dc-meta" role="status">Saved.</span> : null}
            </span>
            {!valid ? <span className="dc-meta" style={{ color: 'var(--warning)' }}>Enter a number from 0 to 10.</span> : null}
          </label>
        </div>
      </section>

      <section className="setd-card">
        <SectionHeader n="" title="Card numbers" />
        <p className="setd-desc">ELVA removes the card number and security code from every fax and portal document when it arrives, and never keeps them. Charge each card from your own fax inbox or the payer&rsquo;s portal.</p>
      </section>

      <section className="setd-card">
        <div className="dc-notice">Later: ELVA will charge cards itself, through your own card processor.</div>
      </section>
    </>
  );
}
